export const userProperties: { [key: string]: string } = {
  "@odata.context": 'URL',
  extension_2cc2f842b72044dcaf51a3fc59fc27c8_EYServiceLineDesc: 'EYServiceLine',
  extension_2cc2f842b72044dcaf51a3fc59fc27c8_EYSubServiceLineDesc: 'EYSubServiceLine',
  extension_2cc2f842b72044dcaf51a3fc59fc27c8_EYSpecialityName: 'EYSpecialityName',
  extension_2cc2f842b72044dcaf51a3fc59fc27c8_EYManagerialAreaDesc1: 'EYArea',
  extension_2cc2f842b72044dcaf51a3fc59fc27c8_EYLocationAddressCountry1: 'EYCountry',
  extension_2cc2f842b72044dcaf51a3fc59fc27c8_EYRankDesc: 'EYRank'
};